export default "__VITE_ASSET__20db363c__"